import React, { useContext, useEffect, useState } from 'react'
import Beneficiaire from './rechargeContainer/beneficiare'

import { Products, RechargeMobile, tracks } from 'requests/transfer'
import UserContext from 'contexts/UserContext'
import PaimentContainer from './rechargeContainer/paimentContainer'
import RecapComponent from 'components/recapComponent'
import { PaymentConfirmed } from 'requests/paiement'
import RechargeContext from 'contexts/rechargeContext'
import OffreRecharge from './rechargeContainer/offreRecharge'
import StepTransfert from 'components/stepTransfert'
import VolumePayment from './rechargePrepayee/paiementCartePrepayee'
import { useNavigate } from 'react-router-dom'
import FlecheRetour from '../assets/arrow-back-navigation.svg'
import { Spinner } from 'utils/loading'
import SecureCardTransfert from 'components/transfertComponent/secureCardTransfert'

interface CarteRecharge {
  ProviderCode: string
  SkuCode: string
  LocalizationKey: string
  SettingDefinitions: any[]
  Maximum: {
    SendCurrencyIso: number
    ReceiveCurrencyIso: string
    ReceiveValueExcludingTax?: number
    SendValue: string
    ReceiveValue: string
  }
}
export default function Recharge() {
  const { recharges, setRecharges } = useContext(RechargeContext)
  const [choixPaiement, setChoixPaiement] = useState<string>('cb')
  const [trackId, setTrackId] = useState('')

  const nomstep = ['Bénéficiaire', 'Offre', 'Paiement']
  const [numStep, setNumStep] = useState(0)

  const [product, setProduct] = useState<CarteRecharge[]>([])
  const [selectProduct, setSelectProduct] = useState<CarteRecharge[]>([])

  const [loading, setLoading] = useState(false)
  const { user, setUser } = useContext(UserContext)
  const navigation = useNavigate()
  const id = user?.user?._id
  const token = user?.token?.accessToken

  const [isOpenModal, setIscloseModal] = useState(false)
  const [selectedValue, setSelectedValue] = useState<string>('')

  const [operateur, setOperateur] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [codeIso, setCodeIso] = useState('')

  const [clientSecret, setClientSecret] = useState('')
  const [rechargeId, setRechargeId] = useState('')
  const [referenceId, setReferenceId] = useState('')
  const [isError, setIsError] = useState(false)
  const [isGift, setIsGift] = useState(false)
  const [isSuccess, setIsSuccess]=useState(true)
  const COUNTRY_MAP: Record<string, string> = {
    TUN: '+216',
    SEN: '+221',
    MAC: '+212',
    PAK: '+92',
    BGD: '+880',
    TUR: '+90',
    NGA: '+234',
    KEN: '+254',
    // PHL: '+63',
  }
  //props payment invoices
  //slected Prefixe
  useEffect(() => {
    if (recharges && recharges.prefix) {
      setSelectedValue(recharges.prefix)
    } else {
      if(user?.user.destinationDefaultCountry &&
      user.user.destinationDefaultCountry in COUNTRY_MAP)
      {setSelectedValue(COUNTRY_MAP[user.user.destinationDefaultCountry])}
      else{setSelectedValue('+216')}
    }
  }, [user])

  useEffect(() => {
    setRecharges({ ...recharges, prefix: selectedValue })
  }, [selectedValue])

  //Liste des operateurs
  useEffect(() => {
      setLoading(false)

    async function fetchData() {
      if (!recharges?.isOperateur) return
      const body = {
        userId: id,
        country: codeIso,
      }
      try {
        const response = await Products(token, body)

        setProduct([])
        if (response?.success) {
          setIsGift(response.isGift?? false)
          setLoading(true)
          const sortedProducts = response.products
            ?.filter((v: any) => v?.Maximum?.ReceiveValue > 6 && v?.Maximum?.SendValue >= 2.5)
            ?.sort((a: any, b: any) => b.Maximum.ReceiveValue - a.Maximum.ReceiveValue) // Sorting in descending order
          setProduct(sortedProducts)
        }
      } catch (error) {
        console.error(error)
      }
    }
    if (numStep === 1) {
      fetchData()
    }
  }, [numStep])

  const functionTracks = async (stepNumber: string) => {
    let dataTracks = {
      label: 'recharge',
      step: stepNumber,
      userId: id,
    }

    if (stepNumber !== '0') {
      const newDataTracks = {
        ...dataTracks,
        trackId: trackId,
      }
      dataTracks = newDataTracks
    }
    try {
      const response = await tracks(dataTracks)
      if (response?.success === true) {
        setTrackId(response?.trackId)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    functionTracks('0')
  }, [])

  // liste des cartes
  useEffect(() => {
    if (recharges && product?.length > 0) {
      const Table = product?.filter((list: any) => list?.ProviderCode === recharges?.isOperateur)
      const uniqueProducts = Array.from(
    new Map(
      Table.map((item: any) => [item.Maximum.ReceiveValue, item])
    ).values()
  )
      setSelectProduct(uniqueProducts)
    }
  }, [recharges, product])

  const [buttonClicked, setButtonClicked] = useState(false)
  const [selectionCount, setSelectionCount] = useState(0)
  const FNPayer = async () => {
    setLoading(true)
    const dataRecharge = {
      userId: id,
      SkuCode: recharges?.SkuCode,
      SendValue: recharges?.MontantEur,
      SendCurrencyIso: recharges?.MontantTnd,
      AccountNumber: `${phoneNumber || recharges?.phoneNumber}`,
      DistributorRef: operateur ? operateur : recharges?.isOperateur,
      platform: 'web',
    }
    setLoading(false)

    try {
      const response = await RechargeMobile(id, token, dataRecharge, choixPaiement)
      if (response?.context === 'gift_recharge' && user?.user) {
        // setRechargeId(response?.recharge_id)

        confirmPaymentGift(response?.recharge_id)
      } else if (response?.success === true) {
      setLoading(true)

        setClientSecret(response?.client_secret)
        setRechargeId(response?.recharge_id)
        setReferenceId(response.reference)
      } else {
        console.error('response failed', response)
        setIsError(true)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(true)
    }
  }

  const confirmPaymentGift = async (id: string) => {
    const body = {
      recharge_id: id,
    }
    try {
      const response = await PaymentConfirmed(body, token, choixPaiement)
      if (response?.success === true) {
        setIscloseModal(true)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }

  const confirmPayment = async () => {
    const body = {
      recharge_id: rechargeId,
    }
    try {
      const response = await PaymentConfirmed(body, token, choixPaiement)
      if (response?.success === true) {
        console.log('PaymentConfirmed', response)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className="flex w-full  place-items-end mb-20  ">
      <div className="flex flex-col w-[70%] 3xl:w-[60%] lg:w-full px-[140px] 3xl:px-[40px] sm:px-0  items-center justify-center xl:w-full lg:mt-[40px] sm:mt-[20px]">
        <div className="flex w-full items-center">
          <button
            type="button"
            onClick={() => navigation('/')}
            className="hidden lg:block cursor-pointer"
            aria-label="Retour à la page précédente"
          >
            <img src={FlecheRetour} alt="" />
          </button>
          <h1 className="h1 w-full"> Nouvelle Recharge </h1>
        </div>

        <div className="flex justify-between w-full ">
          {nomstep.map((item, index) => (
            <StepTransfert
              key={index}
              nomStep={item}
              numStep={index + 1}
              isActive={index <= numStep}
              lastStep={index < 2 ? true : false}
              isComplete={numStep > index}
              setNumStep={setNumStep}
            />
          ))}
        </div>
        {numStep !== 2 && <h2 className="h2 flex w-full items-start mb-[20px]">Envoyez une recharge mobile</h2>}

        {numStep === 0 && (
          <Beneficiaire
            prefixeSelected={selectedValue}
            setPrefixeSelected={setSelectedValue}
            setChoixPaiement={setChoixPaiement}
            onChangeStep={() => setNumStep(1)}
            functionTracks={functionTracks}
            setCodeIso={setCodeIso}
          />
        )}

        {numStep === 1 && (
          <div>
            {!loading || !selectProduct ? (
              <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" fadeIn="none" />
            ) : (
              <OffreRecharge
                listeCarte={selectProduct}
                onBackChangeStep={() => setNumStep(0)}
                onChangeStep={() => setNumStep(2)}
                setListeCarte={setSelectProduct}
                FNPayer={FNPayer}
                functionTracks={functionTracks}
              />
            )}
          </div>
        )}

        {numStep === 2 && (
          <>
            {!loading ? (
              <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" fadeIn="none" />
            ) : clientSecret ? 
              <>{
                isSuccess ?
                <PaimentContainer
                FNPayer={FNPayer}
                SendValue={recharges?.MontantEur}
                clientSecret={clientSecret}
                confirmPayment={confirmPayment}
                setIsSuccess={setIsSuccess}
                buttonClicked={buttonClicked}
                selectionCount={selectionCount}
                functionTracks={functionTracks}
              />
            :
            <span className='font-semibold text-[#EE443F]'>
               Une erreur est survenue lors du traitement de votre demande. <br/> Veuillez réessayer ultérieurement. 
            </span>}
              </>
            : referenceId ? (
              <VolumePayment
                amount={Number(recharges?.MontantEur)}
                reference={referenceId}
                merchantPaymentId={referenceId}
              />
            ) : (
              isError && <div className=" font-bold text-[20px]">Erreur serveur, veuillez réessayer plus tard</div>
            )}{' '}
          </>
        )}
      </div>
      <div className={` fixed bottom-0 mb-[100px] right-0  xl:hidden`}>
        <RecapComponent
          Bénéficiaire={true}
          prefix={recharges?.prefix}
          phoneNumber={recharges?.phoneNumber}
          operateur={recharges?.labelOperateur}
          montantEur={isGift ? '0' : recharges?.MontantEur}
          montantTnd={recharges?.MontantDinar}
          taxeLocale={recharges?.ReceiveValueExcludingTax}
          isTaxe={true}
          devise={recharges?.ReceiveCurrencyIso}
        />
      </div>

      <SecureCardTransfert
        responseSuccess={true}
        isOpen={isOpenModal}
        closeModal={() => setIscloseModal(false)}
        rechargePage="3"
        transfertPage={4}
      />
    </div>
  )
}
